import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false,
    loaderCount: 0,
    pusherInstance: null,
    user: null,
  },

  actions: {
    setPusherInstance({ commit }, payload) {
      commit('SET_PUSHER_INSTANCE', payload)
    },

    setLoggedIn({ commit, dispatch }, payload) {
      if (payload === false) {
        commit('SET_USER', null)
        commit('SET_LOGGED_IN', payload)

        // Delete token cookie.
        return Vue.prototype.$APICall(
          'post',
          'CLEAR_TOKEN_COOKIE',
          '',
          [],
          () => {},
          false
        )
      }

      return dispatch('user').then(() => {
        commit('SET_LOGGED_IN', payload)
      })
    },

    async user({ commit }) {
      await Vue.prototype.$APICall(
        'get',
        'USER_PROFILE',
        '',
        {},
        data => {
          commit('SET_USER', data.data)
        },
        false,
        null
      )
    },
  },

  getters: {
    isAuthenticated: state => !!state.loggedIn,
  },

  mutations: {
    SET_PUSHER_INSTANCE(state, value) {
      state.pusherInstance = value
    },

    SET_USER(state, value) {
      state.user = value
    },

    SET_LOGGED_IN(state, value) {
      state.loggedIn = value
    },

    increaseLoaderCount(state) {
      setTimeout(() => {
        state.loaderCount++
      }, 500)
    },

    decreaseLoaderCount(state) {
      state.loaderCount--
    },
  },
})
